module.exports = __webpack_public_path__ + "img/part3.654518b4.png";